"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRequestPlanningItemApproveLeadQuoteBody = void 0;
const iplanning_item_entity_1 = require("./iplanning-item-entity");
function parseRequestPlanningItemApproveLeadQuoteBody(data) {
    if (data.planning_item_placement_to_create !== null && typeof data.planning_item_placement_to_create === 'object')
        data.planning_item_placement_to_create = (0, iplanning_item_entity_1.parseIPlanningItemEntity)(data.planning_item_placement_to_create);
    return data;
}
exports.parseRequestPlanningItemApproveLeadQuoteBody = parseRequestPlanningItemApproveLeadQuoteBody;
